module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAACE3AAAhNwEzWJ96AAABAUlEQVRoge3Z0Q2CMBDG8T/GAdhEB2AIR9AFSNxAV3AB3cQX98JgjCE+EKBH776k3yMhzf1CgfZKSUmJdqpc1XdtsweewLm6vR5W42YBDIqvv5dOVoiNxSALcu/a5mgxkMcUqgeXk59ENgArIbICWAGRHYAxwgWAIcINgBHCFdAnFeEOIBERAkACIgyAhYhQABYgwgGYiQgJYAYiLICJiKprm4tPeZOzAw5/N/8QPaCLW/toPgivDY1ZtsA1eI3jU8inpmmZ9BIHrV37Myr9I5NeSkgv5qSX09IbGuktpfSmXrqtIt3Ykm4tSjd3pdvraxWP4wmN2RGT/CFfSUmJcoA3vhSyhT2I0KwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/ic_btn_arrow2_sp@3x.png
// module id = 302
// module chunks = 0